import api from "./axios";

export const WeddingStore = async ({ category, location, search, see_all }) => {
  const response = await api.get("/store/wedding-stores", {
    params: {
      category,
      location,
      search,
      see_all
    },
  });
  return response.data.data.store_data;
};

export const weddingBanner = async () => {
  const response = await api.get("/store/wedding-banners");
  return response.data.data.banners;
};

export const storeLocations = async () => {
  const response = await api.get("/store/store-location");
  return response.data.data.location_list;
};

export const storeCategory = async () => {
  const response = await api.get("/store/category");
  return response.data?.data;
};
